var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.cell
    ? _c("table", [
        _c("tbody", [
          _c("tr", [
            _c("td", [
              _c("div", [
                _vm.isMaintenance
                  ? _c("span", [_vm._v(_vm._s(_vm.$t("txtCellName")))])
                  : _c("span", [_vm._v(_vm._s(_vm.$t("txtObjectName")))])
              ]),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form-control mb-0", attrs: { type: "text" } },
                [_vm._v(_vm._s(_vm.cell.name))]
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("cellMeterKM")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.kmMeter,
                    expression: "misc.kmMeter"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.kmMeter },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "kmMeter", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("cellMeterTank1")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.tank1,
                    expression: "misc.tank1"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.tank1 },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "tank1", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("cellMeterTank2")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.tank2,
                    expression: "misc.tank2"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.tank2 },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "tank2", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("txtDescription")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.tankDesc,
                    expression: "misc.tankDesc"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.tankDesc },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "tankDesc", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("cellMeterMotor1")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.motorMeter1,
                    expression: "misc.motorMeter1"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.motorMeter1 },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "motorMeter1", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("cellMeterCableHours")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.CableHours,
                    expression: "misc.CableHours"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.CableHours },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "CableHours", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("txtDescription")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.motorDesc,
                    expression: "misc.motorDesc"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.motorDesc },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "motorDesc", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("cellLiquidOilLevel1")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.OilLevel1,
                    expression: "misc.OilLevel1"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.OilLevel1 },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "OilLevel1", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("cellLiquidOilLevel2")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.OilLevel2,
                    expression: "misc.OilLevel2"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.OilLevel2 },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "OilLevel2", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("txtDescription")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.oilDesc,
                    expression: "misc.oilDesc"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.oilDesc },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "oilDesc", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("cellLiquidLevel1")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.LiquidLevel1,
                    expression: "misc.LiquidLevel1"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.LiquidLevel1 },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "LiquidLevel1", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("cellLiquidLevel2")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.LiquidLevel2,
                    expression: "misc.LiquidLevel2"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.LiquidLevel2 },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "LiquidLevel2", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", [_vm._v(_vm._s(_vm.$t("txtDescription")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.misc.liquidDesc,
                    expression: "misc.liquidDesc"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.misc.liquidDesc },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.misc, "liquidDesc", $event.target.value)
                  }
                }
              })
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }